import React from "react";
import { STATUS_LABELS, STATUS_STYLES } from "@/lib/invoice";
import { cn } from "@/lib/utils";

export const StatusBadge = ({ status, className }) => (
  <span
    data-testid={`status-badge-${status}`}
    className={cn(
      "inline-flex items-center px-2.5 py-0.5 text-xs font-medium border rounded-none uppercase tracking-wide",
      STATUS_STYLES[status] || STATUS_STYLES.offen,
      className
    )}
  >
    {STATUS_LABELS[status] || status}
  </span>
);
